import { Routes, Route } from "react-router-dom";

import ManifestoListScreen from "screens/App/CRM/Manifesto/ManifestoListScreen";
import ManifestoCreateScreen from "screens/App/CRM/Manifesto/ManifestoCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const ManifestoRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<ManifestoListScreen />} />
      <Route path="create" element={<ManifestoCreateScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default ManifestoRouter;
